import Env from '../base/env'
import YouTubePlayer from 'youtube-player'

export default class PlayerYT
{
    constructor(view=null)
    {
        if(view != null)
        {
            this.view = view
            this.$views = this.view.querySelectorAll('.jsPlayerYT--view')
            this.$triggers = this.view.querySelectorAll('.jsPlayerYT--trigger')
            this.$receptors = this.view.querySelectorAll('.jsPlayerYT--receptor')
            this.players = []
            this.stateNames = {
                '-1': 'unstarted',
                0: 'ended',
                1: 'playing',
                2: 'paused',
                3: 'buffering',
                5: 'video cued'
            };
            this.install()
            this.events()
        }
        else
        {
            return
        }
    }

    events()
    {
        // this.$triggers.forEach((e)=>
        for(let i = 0; i < this.$triggers.length; i++) {
            const $trigger = this.$triggers[i]
            $trigger.addEventListener('click',()=>{
                this.launchVideo(i)
            },false)
        }
    }

    destroy()
    {
        for(let i = 0; i < this.players.length; i++) {
            let theplayer = this.players[i]
            theplayer.destroy()
        }
    }

    install()
    {

        for(let i = 0; i < this.$views.length; i++) {
            const $view = this.$views[i]
            const $receptor = this.$receptors[i]
            const $btnClose = $view.querySelector('.jsPlayerYT--close')
            const id = 'playerBody-'+Env.framework.toolbox.guid()
            const dimensions = $view.getBoundingClientRect()
            let theplayer,options


            // ATTRIBUTES
            $receptor.setAttribute('id',id)
            $receptor.setAttribute('data-width',dimensions.width)
            $receptor.setAttribute('data-height',dimensions.height)
            $receptor.setAttribute('data-index',i)

            // PLAYER
            if ($receptor.tagName !== 'iframe')
            {
                options = {
                    height: "100%",
                    width: "100%",
                    videoId: $receptor.getAttribute('data-videourl').split('https://www.youtube.com/watch?v=')[1],
                    playerVars : { autoplay: 0 , controls : 1 , theme : 'dark' , loop : 0 , modestbranding : 1, rel : 0, showinfo : 0, autohide : 1 , playsinline: 0, fs:1 }
                }
            }
            theplayer = YouTubePlayer(id,options);
            theplayer.on('ready',()=> {
                theplayer.stopVideo()
                theplayer.setVolume(100)
            });
            theplayer.on('stateChange', (event)=> {
                const status = this.stateNames[event.data]

                if(status == 'playing') {
                    $view.classList.remove('video--isPausing')
                    $view.classList.add('video--isPlaying')
                } else if(status == 'paused') {
                    $view.classList.remove('video--isPlaying')
                    $view.classList.add('video--isPausing')
                } else if(status == 'ended') {
                    theplayer.stopVideo()
                    if($view.classList.contains('video--isPausing')) $view.classList.remove('video--isPausing')
                    if($view.classList.contains('video--isPlaying')) $view.classList.remove('video--isPlaying')
                }
            });
            if($btnClose !== null) {
                $btnClose.addEventListener('click',()=>{
                    $view.classList.remove('video--isPausing')
                    $view.classList.remove('video--isPlaying')
                    setTimeout(() => {
                        theplayer.seekTo(1000000)
                    }, 100);
                })
            }
            this.players[i] = theplayer
        }
    }

    launchVideo(index)
    {
        let theplayer = this.players[index]
        if(typeof theplayer == 'object') {
            theplayer.getPlayerState().then((state)=>
            {
                if(state == 5 || state == 2)
                {
                    if(Env.mobile == true) {
                        setTimeout(() => {
                            this.$views[index].classList.add('video--isPlaying')
                        }, 200);

                    }
                    theplayer.playVideo()
                }
                else if(state == 1)
                {
                    theplayer.pauseVideo()
                }
            })
            return;
        }
    }
}